import { createApp, reactive } from 'vue/dist/vue.esm-bundler.js';

const root = document.getElementById('search-app');

if (root) {
	const state = reactive({
		has_result: false,
		loading: false,
		error: '',
		data: { programsPage: [], newsPage: [], eventsPage: [], others: [], virtual: [{}] },
		counts: { programsPage: 0, newsPage: 0, eventsPage: 0, others: 0 },
		lastQuery: '',
		site: root.dataset.site || 'cegep',
		endpoint: '/actions/sitesearch/search/index',
		activeTab: 'virtual',
		limits: { programsPage: 2, newsPage: 6, eventsPage: 2, others: 6 },
		showAll: { programsPage: false, newsPage: false, eventsPage: false, others: false },
	});

	const app = createApp({
		data() {
			return state;
		},
		methods: {
			formatDate(dateStr) {
				if (!dateStr) return ['', ''];

				const parts = dateStr.trim().split(' ');
				const day = parts[0];
				const monthName = parts[1];

				const months = {
					janvier: 'JAN',
					fevrier: 'FEB',
					'f\u00e9vrier': 'FEB',
					mars: 'MAR',
					avril: 'APR',
					mai: 'MAY',
					juin: 'JUN',
					juillet: 'JUL',
					aout: 'AUG',
					'ao\u00fbt': 'AUG',
					septembre: 'SEP',
					octobre: 'OCT',
					novembre: 'NOV',
					decembre: 'DEC',
					'd\u00e9cembre': 'DEC'
				};

				return [day, months[monthName.toLowerCase()] || ''];
			},

			displayed(bucket) {
				const arr = this.data[bucket] || [];
				const isAllTab = this.activeTab === 'virtual';
				const isItsTab = this.activeTab === bucket;
				const expanded = this.showAll[bucket];

				if (isAllTab) return arr.slice(0, this.limits[bucket] || 0);
				if (isItsTab || expanded) return arr;

				return [];
			},

			setActive(bucket) {
				this.activeTab = bucket;
				if (bucket !== 'virtual') this.showAll[bucket] = true;
			},

			openAll(bucket) {
				this.setActive(bucket);
			},

			async search(q, site = this.site) {
				this.loading = true;
				this.error = '';
				this.lastQuery = q;

				const url = new URL(this.endpoint, window.location.origin);
				url.searchParams.set('query', q || '');
				url.searchParams.set('site', site || 'cegep');

				try {
					const res = await fetch(url.toString(), { credentials: 'include' });
					if (!res.ok) throw new Error('HTTP ' + res.status);
					const json = await res.json();

					this.data = {
						programsPage: json.data?.programsPage || [],
						newsPage: json.data?.newsPage || [],
						eventsPage: json.data?.eventsPage || [],
						others: json.data?.others || [],
						virtual: [{}],
					};
					this.counts = {
						programsPage: json.programsPage ?? (this.data.programsPage?.length || 0),
						newsPage: json.newsPage ?? (this.data.newsPage?.length || 0),
						eventsPage: json.eventsPage ?? (this.data.eventsPage?.length || 0),
						others: json.others ?? (this.data.others?.length || 0),
					};

					this.activeTab = 'virtual';
					this.showAll = { programsPage: false, newsPage: false, eventsPage: false, others: false };
				} catch (e) {
					this.error = e.message || 'Erreur reseau';
				} finally {
					this.loading = false;
					this.has_result = true;
				}
			},
		},
		mounted() {
			const form = document.getElementById('global-search-form');
			const input = document.getElementById('global-search-input');

			if (form && input) {
				form.addEventListener('submit', (e) => {
					e.preventDefault();
					this.search(input.value, this.site);
				});
			}
		}
	});

	app.config.compilerOptions.delimiters = ['[[', ']]'];
	app.mount(root);
}
